const getImage = (id) => {
  return /* GraphQL */ `
    query GetImage {
      getImage(id: "${id}") {
        id
        category
        url
        note
        index
        status
        timeToDelete
        assetEntityID
        createdAt
        updatedAt
        userID
        createdByID
        activityID
        clanID
        postID
        chatChannelMessageID
        typeIDPK
        __typename
      }
    }
  `;
};

export default getImage;